import { render, staticRenderFns } from "./onLineStudyDetail.vue?vue&type=template&id=b59b92e2&scoped=true&"
import script from "./onLineStudyDetail.vue?vue&type=script&lang=js&"
export * from "./onLineStudyDetail.vue?vue&type=script&lang=js&"
import style0 from "./onLineStudyDetail.vue?vue&type=style&index=0&id=b59b92e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59b92e2",
  null
  
)

export default component.exports